import { LazyLoadImage } from "react-lazy-load-image-component";
import { resolveObjectFit } from '../../../utils/imageFit';

import RssPreview from "../RSS/RssPreview";
import VideoJS from "./VideoJS";

const Media = ({ data, stretch = false, imageFit = null }) => {
    // `stretch` is the legacy boolean and means "do NOT maintain aspect ratio",
    // so it inverts into the resolver's maintainAspectRatio.
    const objectFit = resolveObjectFit(imageFit ?? data?.image_fit, !stretch);
    var html = null;
    if (data.path.includes(".m3u8")) {
        const play = {
            fill: true,
            fluid: true,
            autoplay: true,
            controls: true,
            preload: "metadata",
            sources: [
                {
                    src: data.path,
                    type: "application/x-mpegURL",
                },
            ],
        };
        html = <VideoJS {...play} />;

    } else if (data.type == "IMAGE" || data.type == "CORNER") {
        html = (
            <div className="media-previewer w-100 h-100 flex  justify-content-center" >
                <LazyLoadImage src={data.path} style={{
                    width: '100%',
                    height: '100%',
                    objectFit,
                }} />
            </div>
        );

    } else if (data.type == "VIDEO") {
        if (data.path.endsWith(".avi")) {
            html = (
                <div className="text-center mt-5">
                    <p>Your browser may not support this format.</p>
                    <a href={data.path} download>Download the file</a>
                </div>
            );
        } else {
            html = (
                <video width="100%" height="100%" className="h-100" controls style={{ objectFit }}>
                    <source src={data.path} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            );
        }
    } else if (data.type == "YOUTUBE") {
        const videoId = new URLSearchParams(new URL(data.path).search).get("v");
        let newPath = `https://www.youtube.com/embed/${videoId}?controls=1`;
        // var newPath = data.path.replace("watch?v=", "embed/");
        html = (
            <iframe
                style={{ display: 'block', border: 'none' }}
                height={stretch ? '100%' : '315'}
                className="w-100" src={newPath} title="YouTube video player" frameborder="0"></iframe>
        );

    } else if (data.type == "AUDIO") {
        html = (
            <audio controls className="w-full">
                <source src={data.path} type="audio/ogg"></source>
            </audio>
        );
    } else if (["CHANNEL", "HDMI"].includes(data.type)) {
        html = (
            <div className="w-100 d-flex w-100 h-100 bg-secondary text-white  fs-1 justify-content-center align-items-center">
                <span>{data.type == "CHANNEL" ? "Channel" : "HDMI"}</span>
            </div>
        );
    } else if (data.type == "3D") {
        let _path = `${process.env.REACT_APP_3D_VIEWER_URL}?id=${data?.id}&token=${localStorage.getItem("access_token")}`
        html = <iframe className="w-100" style={{ minHeight: "500px", height: "100%" }} src={_path} title="YouTube video player" frameborder="0"></iframe>
    } else if (["RSS", "RSS_CUSTOM"].includes(data.type)) {
        html = <RssPreview rssURL={data?.path} />;
    } else if (data.type == "CLOCK") {
        let _path = `${data.path}?id=${data?.id}&token=${localStorage.getItem("access_token")}`
        html = <iframe className="w-100" style={{ minHeight: "500px", height: "100%" }} src={_path} title="Clock Panel Preview" frameborder="0"></iframe>;
    }

    else if (data.type == "WEATHER") {
        let _path = `${data.path}?id=${data?.id}&token=${localStorage.getItem("access_token")}`
        html = <iframe className="w-100" style={{ minHeight: "350px", height: "100%" }} src={_path} title="Weather Panel Preview" frameborder="0"></iframe>;
    }
    else {
        html = <iframe src={data.path} className="w-100" height="500"></iframe>;
    }

    return (
        <>
            {stretch ?
                <div style={{ width: '100%', height: '100%' }}>
                    {html}
                </div>
                :

                html
            }
        </>
    )

}

export { Media }